"use client";

import { HelpCircle } from "lucide-react";
import {
  openPylonChat,
  usePylonReady,
  usePylonUnreadMessagesCount,
} from "@/app/providers/pylon-provider";
import { SidebarMenuButton, SidebarMenuItem } from "./ui/sidebar";

export const HelpSidebarButton = () => {
  const pylonReady = usePylonReady();
  const unreadMessagesCount = usePylonUnreadMessagesCount();

  return (
    <SidebarMenuItem>
      <SidebarMenuButton
        onClick={openPylonChat}
        disabled={!pylonReady}
        tooltip="Support"
      >
        <span className="relative flex size-4 shrink-0 items-center justify-center">
          <HelpCircle className="size-4" />
          {unreadMessagesCount > 0 && (
            <span
              aria-label="Unread support messages"
              className="absolute -right-0.5 -top-0.5 size-1.5 rounded-full bg-destructive"
            />
          )}
        </span>
        <span data-sidebar="menu-label">Support</span>
      </SidebarMenuButton>
    </SidebarMenuItem>
  );
};
